import { BlogSection } from '@/types/blog';

export const transaktionenSection: BlogSection = {
  id: 'transaktionen',
  title: 'Steuerpflichtige Transaktionen im Überblick',
  content: `
    <p>
      Das Finanzamt betrachtet verschiedene Krypto-Aktivitäten als steuerrelevant:
    </p>

    <ul>
      <li><strong>Verkauf gegen Euro oder andere Währungen:</strong> Der klassische Fall – du verkaufst Bitcoin und erhältst Euro.</li>
      <li><strong>Tausch gegen andere Kryptowährungen:</strong> Auch wenn du Bitcoin gegen Ether tauschst, gilt dies steuerlich als Verkauf des Bitcoin mit anschließendem Kauf von Ether.</li>
      <li><strong>Verwendung als Zahlungsmittel:</strong> Bezahlst du Waren oder Dienstleistungen mit Kryptowährungen, stellst du steuerlich einen Verkauf der Kryptowährung dar.</li>
    </ul>

    <p>
      Bei der Berechnung deiner Gewinne akzeptiert das Finanzamt die <strong>First in, First out (FiFo)-Methode</strong> als Vereinfachung. Dies bedeutet: Die zuerst erworbenen Coins gelten steuerlich als zuerst verkauft. Eine sorgfältige Dokumentation deiner Transaktionen ist daher unerlässlich.
    </p>
  `
};
